import { NgFor, NgIf } from '@angular/common'
import { Component } from '@angular/core'
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatNativeDateModule } from '@angular/material/core'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatDialogRef } from '@angular/material/dialog'
import {
    MatError,
    MatFormField,
    MatFormFieldModule,
    MatLabel,
} from '@angular/material/form-field'
import { MatIcon, MatIconModule } from '@angular/material/icon'
import { MatInput, MatInputModule } from '@angular/material/input'
import { MatRadioModule } from '@angular/material/radio'
import { MatSelectModule } from '@angular/material/select'
import { MatStepperModule } from '@angular/material/stepper'
import {
    SocialSecurity,
    SocialSecurityDTO,
} from '../../models/socialsecurity.interface'
import { ToastrService } from 'ngx-toastr'
import { SocialsecurityService } from '../../services/socialsecurity/socialsecurity.service'
import { HttpErrorResponse } from '@angular/common/http'
import { eps, insuranceKind } from '../incident-observatorio/incident-form/incident.definitions'

@Component({
    selector: 'app-socialsecurity-form',
    standalone: true,
    imports: [
        MatStepperModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatError,
        MatIcon,
        MatIconModule,
        MatCheckboxModule,
        MatRadioModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        NgIf,
        NgFor,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
    ],
    templateUrl: './socialsecurity-form.component.html',
    styleUrl: './socialsecurity-form.component.css',
})
export class SocialsecurityFormComponent {
    selectedSocialSecurity: SocialSecurity | null = null
    socialSecurityId: string | null = null
    errorMsg: string[] | null = null
    insuranceKind = insuranceKind
    eps = eps

    constructor(
        private dialogRef: MatDialogRef<SocialsecurityFormComponent>,
        private fb: FormBuilder,
        private toastr: ToastrService,
        private socialSecurityService: SocialsecurityService
    ) {}

    ngOnInit(): void {
        this.socialSecurityService.$socialsecuritiesSelected.subscribe(
            (socialSecurity) => {
                if (socialSecurity) {
                    this.socialSecurityId = String(socialSecurity.id)
                    this.selectedSocialSecurity = socialSecurity
                    this.editSocialSecurityForm.patchValue({
                        ...socialSecurity,
                    })
                }
            }
        )
    }

    editSocialSecurityForm = this.fb.group({
        eps: ['', []],
        hasInsurance: [false],
        insuranceKind: ['', []],
    })

    closeDialog() {
        this.dialogRef.close()
    }

    updateSocialSecurity() {
        const payload = this.editSocialSecurityForm.value as SocialSecurityDTO
        if (
            this.editSocialSecurityForm.status === 'VALID' &&
            this.socialSecurityId
        ) {
            if (this.editSocialSecurityForm.pristine) {
                this.dialogRef.close()
                return
            }
            const id = Number(this.socialSecurityId)
            this.socialSecurityService
                .updateSocialSecurity(id, { ...payload, id: id })
                .subscribe({
                    next: (socialSecurity) => {
                        const msg = `El registro fue EDITADO correctamente!`
                        this.toastr.success(msg, 'Exitoso!', {
                            progressBar: true,
                            timeOut: 5000,
                        })
                        this.dialogRef.close()
                    },
                    error: ({}: HttpErrorResponse) => {
                        if (this.errorMsg) {
                            this.toastr.error(
                                'Error: ' + this.errorMsg,
                                undefined,
                                {
                                    progressBar: true,
                                    timeOut: 5000,
                                }
                            )
                        }
                    },
                })
        }
    }
}
